import manuscriptTemplateHwp from '@/assets/files/논문투고양식(개정).hwp';
import ethicsPledgeFormHwp from '@/assets/files/윤리서약서.hwp';
import copyrightConsentFormHwp from '@/assets/files/저작권이양동의서.hwp';

export const publicationAssets = {
	copyrightConsentFormHwp,
	ethicsPledgeFormHwp,
	manuscriptTemplateHwp,
} as const;
